module.exports = __webpack_public_path__ + "static/media/alchemist-helmet-1.fb2e14e4.glb";